import { defineFcm } from '../shared/factory';

export const FCM_PETITION_UPDATE_EMAIL_PREVIEW_ENABLED = defineFcm('petition_update_email_preview_enabled')
	.asBoolean()
	.withDefault(false)
	.toConfig();
